export function extractFAQs(longDescription: string): {
  description: string;
  faqs: string;
} {
  const patterns = [
    /(?:<h[1-4][^>]*>|\b)FAQs?(?:<\/h[1-4]>|\b)/i,

    /(?:<h[1-4][^>]*>)(?:<strong>)?\s*Frequently\s+Ask\s+Question\s*(?:<\/strong>)?(?:<\/h[1-4]>)/i
  ];

  for (const pattern of patterns) {
    const match = longDescription.match(pattern);
    if (match) {
      const headingEndIndex = match.index! + match[0].length;

      const faqStartIndex = longDescription.indexOf('\n', headingEndIndex);

      const startIndex =
        faqStartIndex === -1 ? headingEndIndex : faqStartIndex + 1;

      return {
        description: longDescription.slice(0, match.index!).trim(),
        faqs: longDescription.slice(startIndex).trim()
      };
    }
  }

  return { description: longDescription, faqs: '' };
}
